/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarNav/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import ArrowLeft from 'DesignSystem/Svgs/ArrowLeft/index'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CalendarNav({
  children,
  viewPath = "/DesignSystem/Calendar/CalendarNav",
  onClickPrevMonth,
  text = "May 2019",
  onClickNextMonth
  
}) {
  return (<React.Fragment
>
<div
  data-testid="CalendarNav.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 onClick={onClickPrevMonth}
>
{childProps => (
<ArrowLeft
{...childProps}
  viewPath={`${viewPath}/ArrowLeft`}
 width={12}
 height={12}
/>
)}
</ButtonIcon>
<span
  data-testid="CalendarNav.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 onClick={onClickNextMonth}
>
{childProps => (
<ArrowRight
{...childProps}
  viewPath={`${viewPath}/ArrowRight`}
 width={12}
 height={12}
/>
)}
</ButtonIcon>
</div>
{children}
</React.Fragment>)
}